import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles({
  linkItem: {
    textAlign: "left",
    marginTop: 25,
    marginLeft: "20%",
    marginBottom: 20,
  },
  link: {
    color: "#19334e",
    "&:hover": {
      color: "#39a3e3",
    },
  },
  linkIcon: {
    marginRight: 10,
  },
  mobileHide: {
    "@media (max-width:768px)": {
      display: "none",
    },
  },
  "@media (max-width:768px)": {
    linkItem: {
      textAlign: "center",
    },
    linkIcon: {
      marginRight: 25,
      fontSize: "40px !important",
    },
  },

  "@media (max-width:600px)": {
    linkIcon: {
      fontSize: "30px !important",
    },
  },
});
